<template>
  <div id="Topbar">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/image">Images</router-link> |
      <router-link to="/testimony">Testimony</router-link> |
      <router-link to="/admin">Admin</router-link>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import "../assets/common.scss";

#nav {
  padding: 30px;

  a {
    text-decoration: none;
    font-weight: bold;
    color: $content-colour;

    &.router-link-exact-active {
      color: $active-colour;
      // text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
